/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

import React from "react";
import {
  SiPlex,
  SiJellyfin,
  SiSonarr,
  SiRadarr,
  SiQbittorrent,
  SiTransmission,
  SiPortainer,
  SiPihole,
  SiAdguard,
  SiGrafana,
  SiPrometheus,
  SiHomeassistant,
  SiNextcloud,
  SiSynology,
  SiProxmox,
  SiTruenas,
  SiImmich,
  SiPaperlessngx,
  SiUptimekuma,
  SiVaultwarden,
  SiBitwarden,
  SiGitea,
  SiNginx,
  SiNginxproxymanager,
  SiTraefikproxy,
  SiWireguard,
  SiMinio,
  SiPostgresql,
  SiMariadb,
  SiRedis,
  SiDocker,
  SiHomepage,
} from "react-icons/si";
import { TailscaleLogo } from "@/components/icons/TailscaleLogo";

export interface ServiceIconEntry {
  label: string;
  Icon: React.ComponentType<{ className?: string }>;
}

// Curated set of common self-hosted app brand icons for the Home tab's
// service tiles. Anything not covered here can still be added via a custom
// image-URL icon on the service form.
export const SERVICE_ICONS: Record<string, ServiceIconEntry> = {
  plex: { label: "Plex", Icon: SiPlex },
  jellyfin: { label: "Jellyfin", Icon: SiJellyfin },
  sonarr: { label: "Sonarr", Icon: SiSonarr },
  radarr: { label: "Radarr", Icon: SiRadarr },
  qbittorrent: { label: "qBittorrent", Icon: SiQbittorrent },
  transmission: { label: "Transmission", Icon: SiTransmission },
  portainer: { label: "Portainer", Icon: SiPortainer },
  pihole: { label: "Pi-hole", Icon: SiPihole },
  adguard: { label: "AdGuard Home", Icon: SiAdguard },
  grafana: { label: "Grafana", Icon: SiGrafana },
  prometheus: { label: "Prometheus", Icon: SiPrometheus },
  homeassistant: { label: "Home Assistant", Icon: SiHomeassistant },
  nextcloud: { label: "Nextcloud", Icon: SiNextcloud },
  synology: { label: "Synology", Icon: SiSynology },
  proxmox: { label: "Proxmox", Icon: SiProxmox },
  truenas: { label: "TrueNAS", Icon: SiTruenas },
  immich: { label: "Immich", Icon: SiImmich },
  paperlessngx: { label: "Paperless-ngx", Icon: SiPaperlessngx },
  uptimekuma: { label: "Uptime Kuma", Icon: SiUptimekuma },
  vaultwarden: { label: "Vaultwarden", Icon: SiVaultwarden },
  bitwarden: { label: "Bitwarden", Icon: SiBitwarden },
  gitea: { label: "Gitea", Icon: SiGitea },
  nginx: { label: "Nginx", Icon: SiNginx },
  nginxproxymanager: { label: "Nginx Proxy Manager", Icon: SiNginxproxymanager },
  traefik: { label: "Traefik", Icon: SiTraefikproxy },
  wireguard: { label: "WireGuard", Icon: SiWireguard },
  minio: { label: "MinIO", Icon: SiMinio },
  postgresql: { label: "PostgreSQL", Icon: SiPostgresql },
  mariadb: { label: "MariaDB", Icon: SiMariadb },
  redis: { label: "Redis", Icon: SiRedis },
  docker: { label: "Docker", Icon: SiDocker },
  homepage: { label: "Homepage", Icon: SiHomepage },
  tailscale: { label: "Tailscale", Icon: TailscaleLogo },
};

export const SERVICE_ICON_KEYS = Object.keys(SERVICE_ICONS);
